import {
  baseApi,
} from '@shared/api';
import {
  GameWinnersState,
} from '../model';
import {
  mapGameWinners
} from '../lib';
import {
  LATEST_WINNERS_SIZE,
} from '../config';

export const gameWinnersApiSlice = baseApi.injectEndpoints({
  endpoints: (build) => ({
    getLatestGameWinners: build.query<Maybe<GameWinnersState>, void>({
      query: () => ({ url: `/api/ams/get-latest-winners?size=${LATEST_WINNERS_SIZE}` }),
      extraOptions: { showLoader: false },
      transformResponse: (response: any) => {
        return mapGameWinners(response?.data);
      },
    }),
  }),
});

export const {
  useLazyGetLatestGameWinnersQuery,
  useGetLatestGameWinnersQuery
} = gameWinnersApiSlice;
